import React from 'react';

import { useSelector } from 'react-redux';
import { selectMediaQuery } from 'store/selectors';
import { enOrderBumpStatus } from 'types/enums';
import { IOrderBump } from 'types/interfaces';

import BumpItemDesktop from './Desktop';
import BumpItemMobile from './Mobile';

export const TranslateStatus = {
  [enOrderBumpStatus.ACTIVE]: 'Ativo',
  [enOrderBumpStatus.INACTIVE]: 'Inativo',
  [enOrderBumpStatus.ERROR]: 'Erro',
  [enOrderBumpStatus.ARCHIVED]: 'Requer atenção',
  [enOrderBumpStatus.WARNING]: 'Requer atenção',
  [enOrderBumpStatus.REMOVED]: 'Erro'
};

interface IProps extends IOrderBump {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const BumpItem: React.FC<IProps> = props => {
  const mediaQuery = useSelector(selectMediaQuery);

  if (mediaQuery.md) {
    return <BumpItemMobile {...props} />;
  }

  return <BumpItemDesktop {...props} />;
};

export default React.memo(BumpItem);
